import type { HelpFile } from '../../types/help'
import { TargetSystemsResourcesTestIds } from '../../../testids/TargetSystemsResourcesTestIds'

export const targetSystemsResourcesHelp: HelpFile = {
  docPage: '/docs/systems/overview',
  texts: {
    [TargetSystemsResourcesTestIds.targetSystemsResourcesWelcomeCard]:
      'Startseite des Bereichs Zielsysteme — wählen Sie ein Werkzeug aus der Seitenleiste: Zielsysteme, Ressourcen und Enforcement-Objekte.',
  },
}
